export const LICENSE_KEY = 'e81b1-26020-eafc0-b4726-7581b'
